import { useSelector } from "react-redux";
import { selectNotifications } from "./selector";

export const useNotifications = () => useSelector(selectNotifications);
